import { VoiceChatMutation } from "../types";

export default {
  [VoiceChatMutation.SET_MODE](state: any, payload: any) {
    state.mode = payload;
  },
  [VoiceChatMutation.SET_SESSION_ID](state: any, payload: any) {
    state.sessionId = payload;
  },
  [VoiceChatMutation.SET_HIDE_NOTIFICATION_LABEL](state: any, payload: any) {
    state.hideNotificationLabel = payload;
  },
  [VoiceChatMutation.SET_ROOM_NUMBER](state: any, payload: any) {
    state.roomNumber = payload;
  },
};
